import SharedDateInput from '../shared/DateInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
} from 'reducers/autoPersonalFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface AutoDateInputProps {
  label: string;
  date: Date;
  onChange: any;
  section: number;
  required?: boolean;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  subLabel?: string;
  disabled?: boolean;
  isClearable?: boolean;
}

const AutoDateInput = (props: AutoDateInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark,
    removeRemark,
    updateRemark,
    addFile,
    removeFile,
  };

  return (
    <SharedDateInput
      {...props}
      formStateKey="autoPersonalForm"
      formActions={formActions}
    />
  );
};

export default AutoDateInput;
